import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7256561e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "disabled"]
const _hoisted_2 = { class: "tw-pr-1" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "tw-text-[#FFF] tw-h-[28px]"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "tw-w-2.5",
  viewBox: "0 0 7 6",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M0.0734185 1.60417L3.27583 5.23454C3.30467 5.26503 3.33943 5.28931 3.37797 5.3059C3.41651 5.3225 3.45804 5.33105 3.5 5.33105C3.54196 5.33105 3.58349 5.3225 3.62203 5.3059C3.66057 5.28931 3.69533 5.26503 3.72417 5.23454L6.92658 1.60417C6.95218 1.57533 6.9718 1.5417 6.9843 1.50521C6.99679 1.46873 7.00191 1.43013 6.99936 1.39165C6.99621 1.35286 6.98531 1.3151 6.9673 1.28059C6.9493 1.24609 6.92457 1.21555 6.89456 1.19077L6.35597 0.739521C6.32655 0.714072 6.29233 0.694778 6.25533 0.682777C6.21832 0.670776 6.17929 0.666313 6.14053 0.66965C6.10196 0.672441 6.06433 0.682889 6.02984 0.700383C5.99535 0.717879 5.96469 0.74207 5.93966 0.771545L3.54949 3.52271C3.53477 3.53729 3.51489 3.54546 3.49418 3.54546C3.47346 3.54546 3.45358 3.53729 3.43886 3.52271L1.06034 0.771545C1.01328 0.715332 0.946743 0.678944 0.874022 0.669651C0.835463 0.665917 0.796548 0.669916 0.759554 0.681414C0.722561 0.692912 0.688235 0.711677 0.658587 0.73661L0.105443 1.19077C0.0754336 1.21555 0.0506971 1.24609 0.0326956 1.2806C0.014694 1.3151 0.0037928 1.35286 0.000636374 1.39165C-0.00191233 1.43013 0.00320917 1.46873 0.0157035 1.50521C0.0281978 1.5417 0.0478159 1.57533 0.0734185 1.60417Z" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]

import store from "@/store";
import utilities from "@/utils/utilities";
import CustomDropDown from "@/components/common/customDropDown.vue";
import { computed, onMounted } from "vue";
import { LottieAnimation } from "lottie-web-vue";
import ProgressAnimation from "../../../assets/animation/progress_dark.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'buttonBulkActions',
  props: {
  active: { type: Boolean, required: true, default: false },
  showMoreActions: { type: Boolean, required: false, default: false },
  idPopover: {
    type: String,
    required: false,
    default: `idPopover-bulk-action-${Math.random() * 1000}`,
  },
  buttonClass: { type: String, required: false, default: "" },
  buttonClassHover: {
    type: String,
    required: false,
    default: "",
  },
  showAcctionClick: { type: Boolean, required: false, default: false },
  isMarginRight: { type: Boolean, required: false, default: true },
  selectedNumber: { type: Number, required: false, default: 0 },
  isLoading: { type: Boolean, required: false, default: false },
},
  emits: ["click", "update:showMoreActions"],
  setup(__props, { emit }) {

const props = __props;





const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

onMounted(() => {
  window.addEventListener("click", handleClickOutside);
});

const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const handleClickOutside = (event: MouseEvent) => {
  const button = document.getElementById(props.idPopover);
  const popover = document.querySelector(".b-popover");
  if (
    button &&
    !button.contains(event.target as Node) &&
    popover &&
    !popover.contains(event.target as Node)
  ) {
    emit("update:showMoreActions", false);
  }
};

const onClick = () => {
  emit("click");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      id: props.idPopover,
      disabled: !__props.active,
      class: _normalizeClass([
      `default-button bulk-actions tw-py-4 tw-flex tw-items-center ${
        props.isLoading ? 'tw-pl-4 tw-pr-[5px]' : 'tw-px-4'
      } ${__props.active ? 'hover:!tw-bg-[#211F58] hover:!tw-text-[#FFF]' : ''}`,
      props.buttonClass,
      props.active ? 'hover__button' : 'disable-button',
      (props.showMoreActions && __props.active) || props.isLoading
        ? ' !tw-bg-[#211F58] !tw-text-[#FFF]'
        : props.buttonClassHover,
      props.isMarginRight ? 'tw-mr-5' : '',
    ]),
      type: "button",
      style: _normalizeStyle(!__props.active ? 'cursor: not-allowed;' : 'cursor:pointer;'),
      onClick: onClick
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(`tw-flex tw-items-center ${props.isLoading ? '' : 'tw-pr-2'}`)
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(getUiText("app-table-bulk-actions-text-1")), 1),
        (__props.selectedNumber)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(__props.selectedNumber) + ")", 1))
          : _createCommentVNode("", true)
      ], 2),
      (props.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(LottieAnimation), {
              ref: "anim",
              "animation-data": _unref(ProgressAnimation),
              "auto-play": true,
              loop: true,
              style: { height: '28px' }
            }, null, 8, ["animation-data"])
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass([props.showMoreActions ? 'show' : ''])
          }, _hoisted_6, 2))
    ], 14, _hoisted_1),
    _createVNode(CustomDropDown, {
      "id-popover": props.idPopover,
      class: _normalizeClass(
      !props.showMoreActions
        ? 'tw-invisible'
        : 'tw-border-none bulk-actions-popover'
    ),
      placement: "bottom-end",
      offset: 15,
      "show-acction-click": props.showAcctionClick,
      "show-more-actions": props.showMoreActions
    }, _createSlots({ _: 2 }, [
      (props.showMoreActions && props.active)
        ? {
            name: "default",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["id-popover", "class", "show-acction-click", "show-more-actions"])
  ], 64))
}
}

})